import Cookies from 'js-cookie';
import moment from 'moment';

export const dateFormate = (date: Date | string) => {
  return moment(date).format('MMM D YYYY, HH:mm:ss');
};

export const accessToken = Cookies.get('accessToken');

export const toUpperCase = (str: string) => {
  return str.toUpperCase();
};
